module.exports = __webpack_public_path__ + "static/media/side-plank.0adf827e.jpg";